// extracted by mini-css-extract-plugin
export default {"cls1":"baiet9FixLTlU4rz8tcC","cls2":"Yirv_lcEoJvq0f_H9E0w baiet9FixLTlU4rz8tcC","media-tablet-up":"XUKnHm8j4G7Hgt84mtar","media-desktop-up":"NLDHOZbATrV0sB7lot85"};